<div class="col full-height layout-row">

  <div class="flex-5 layout-column">

    <div class="flex layout-column layout-align-start-center">
      <div class="flex index-border" [style.background-color]="routeColor"></div>
      <div class="activity-index"
           [style.border-color]="routeColor"
           [style.background]="(routeColor + 20)"
           [style.color]="routeColor">
        {{ index }}
      </div>
      <div class="flex index-border" [style.background-color]="routeColor"></div>
    </div>

  </div>

  <div class="flex layout-row">

    <!--Route Main Info-->
    <div class="flex-15 layout-column" [ngClass]="{'layout-align-center-start': task.taskType === 'Internal'}">

      <!--Type-->
      <div
        class="info-row layout-column layout-align-center-start purpose-color br-caption-2 font font-weight-800 text-uppercase"
        [ngClass]="task.taskSpec.purpose">
        <div *ngIf="task.taskType === 'BundledStopover'"
             class="layout-column br-caption-2 font-weight-800 text-uppercase margin-right-5">
          <span>{{ 'Multiple' | translate }}</span>
          <span>{{ 'TASK_PURPOSE.' + task.taskSpec?.purpose | translate }}({{ task.numberOfTasks }})</span>
        </div>
        <span
          *ngIf="task.taskType !== 'BundledStopover'">{{ 'TASK_PURPOSE.' + task.taskSpec.purpose | translate }}</span>
      </div>

      <!--! External and Bringoz ID -->
      <div *ngIf="task.taskType !== 'Internal'" class="info-row layout-column layout-align-center-start">
        <span
          class="br-body-2">{{ task.packageList?.length ? (task.packageList[0].externalId || task.serviceId) : task.serviceId }}</span>

        <div class="text-ellipsis" style="line-height: 15px">
          <span class="br-body-2">{{ task.serviceDisplayId }}</span>
        </div>
      </div>

      <!--Labels-->
      <div *ngIf="task.taskType !== 'Internal'"
           class="info-row layout-row layout-align-start-center">
        <app-bringoz-tags class="layout-row layout-align-start-center"
                          [tags]="task.serviceInfo?.requiredSkills"
                          maxTags="1">

        </app-bringoz-tags>
      </div>

    </div>

    <!--Location / Contact-->
    <div class="flex layout-column">

      <!--Location-->
      <div *ngIf="task.taskSpec.address" class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="location-pin-outline"
                      classSize="md"
                      fill="#484848">

        </bringoz-icon>
        <span class="wrap-text br-body-2 font-weight-600">{{ task.taskSpec.address | bringozAddress }}</span>
      </div>

      <!--Contact-->
      <div *ngIf="task.taskSpec.contact?.name" class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="contact-circle"
                      classSize="md"
                      fill="#484848">

        </bringoz-icon>
        <span bringoz-ppi class="info-row wrap-text br-body-2">{{ task.taskSpec.contact.name }}</span>
      </div>

    </div>

    <!--Account / Weight / Price-->
    <div class="flex-20 layout-column">

      <div *ngIf="task.taskType !== 'Internal'" class="flex layout-column">
        <!--Account-->
        <div class="layout-row layout-align-start-center info-row gap-5">
          <bringoz-icon iconName="account"
                        classSize="md"
                        fill="#484848">

          </bringoz-icon>
          <span class="text-ellipsis br-body-2">{{ task.accountReference?.name }}</span>
        </div>

        <!--Weight-->
        <div class="layout-row layout-align-start-center info-row gap-5">
          <bringoz-icon iconName="weight"
                        classSize="md"
                        fill="#484848">

          </bringoz-icon>
          <span *ngIf="task.taskType !== 'BundledStopover' && task.packageList?.length"
                class="br-body-2">{{ task.packageList[0].items | servicePackageWeight:true }}</span>
          <span *ngIf="task.taskType !== 'BundledStopover' && !task.packageList?.length" class="br-body-2">--</span>
          <span *ngIf="task.taskType === 'BundledStopover'" class="br-body-2">{{ bundleWeight }}</span>
        </div>

        <!--Price-->
        <div class="layout-row layout-align-start-center info-row gap-5">
          <bringoz-icon iconName="dollar-circle"
                        classSize="md"
                        fill="#484848">

          </bringoz-icon>
          <span class="br-body-2">{{ task | taskCourierPrice }}</span>
        </div>
      </div>

    </div>

    <!--Status / Time Window / Service Time-->
    <div class="flex-25 layout-column">

      <!--Status-->
      <div class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="status"
                      classSize="md"
                      fill="#484848">

        </bringoz-icon>
        <app-bringoz-status-tag [status]="task.status"></app-bringoz-status-tag>
      </div>

      <!--Time Window-->
      <div class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="time-window-outline"
                      classSize="md"
                      fill="#484848">

        </bringoz-icon>
        <span class="br-body-2">{{ task.taskSpec | timeWindow }}</span>
        <app-bringoz-time-window-tooltip [isTooltip]="true"
                                         [notBefore]="task.taskSpec?.notBefore"
                                         [notAfter]="task.taskSpec?.notAfter"
                                         [timeZoneId]="task.taskSpec?.address?.zoneIdName"
                                         [configZoneId]="task.configZoneId">
        </app-bringoz-time-window-tooltip>
      </div>

      <!--Service Time-->
      <div class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="timer-outline"
                      classSize="md"
                      fill="#484848">

        </bringoz-icon>
        <div *ngIf="!task.taskSpec.detailedServiceTime"
             class="layout-row layout-align-start-center md-tiny">
          {{ task.taskSpec.serviceTime | bringozTimeConvert: true }}
        </div>

        <app-task-detailed-service-time *ngIf="!!task.taskSpec.detailedServiceTime"
                                        class="margin-left-5"
                                        [fontSize]="'md-tiny'"
                                        [isAllowEdit]="false"
                                        [detailedServiceTime]="task.taskSpec.detailedServiceTime">
        </app-task-detailed-service-time>
      </div>

    </div>

  </div>

</div>
